module.exports = __webpack_public_path__ + "static/scale-model-of-zoomontana-in-billings-montana-3c1dc65d6d1373b564f1d45f3c876dc1.png";